import React from "react";
import clsx from "clsx";
import styles from "./STLoader.module.css";

export const STLoader = ({ className = "" }) => {
  return (
    <div className={styles.loaderWrapper}>
      <div className={styles.loader}>
        <div className={styles.circle}></div>
        <div className={styles.circle}></div>
        <div className={styles.circle}></div>
        <div className={styles.circle}></div>
      </div>
    </div>
  );
};
